import Breadcrumbs from '../components/Breadcrumbs';
import Link from '../components/Link';
import { CONTENT_CLASSES } from '../constants/classNames';
import { CONTACT_EMAIL, PUBLISHER_NAME, PUBLISHER_URL, ROUTES, SITE_NAME } from '../constants/config';
import '../styles/ContentPage.css';

/**
 * Contact details. A plain email link: no forms, so no personal data is collected on the site.
 */
export default function ContactPage() {
  return (
    <article className={CONTENT_CLASSES.root}>
      <Breadcrumbs
        trail={[
          { label: 'Lab', path: ROUTES.LAB },
          { label: 'Contact', path: ROUTES.CONTACT },
        ]}
      />
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>Contact us</h1>
        <p className={CONTENT_CLASSES.lead}>
          We'd love to hear from parents, teachers and grown-ups: ideas for new reactions, corrections, or how you use{' '}
          {SITE_NAME} in class.
        </p>
      </header>
      <section className={CONTENT_CLASSES.section}>
        <p className={CONTENT_CLASSES.text}>
          Email us at <strong>{CONTACT_EMAIL}</strong> (<a href={`mailto:${CONTACT_EMAIL}`}>send an email</a>).
        </p>
        <p className={CONTENT_CLASSES.text}>
          {SITE_NAME} is a project of <a href={PUBLISHER_URL}>{PUBLISHER_NAME}</a>.
        </p>
        <p className={CONTENT_CLASSES.text}>
          Kids: please ask a grown-up to write to us for you, and never send us your full name, address or photos.
          Read our <Link to={ROUTES.PRIVACY}>privacy policy</Link> to see how we keep {SITE_NAME} safe.
        </p>
      </section>
    </article>
  );
}
